function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var _excluded = ["disabled", "isTabStats"];

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { Link45deg, PinFill } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { generatePermalink } from '../permalink';
import { useFormContext } from '../state/form';
import { InlineCopy } from './InlineCopy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PermalinkButton(_ref) {
  var disabled = _ref.disabled,
      isTabStats = _ref.isTabStats,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useFormContext = useFormContext(),
      form = _useFormContext.state.form;

  var url = generatePermalink(form, isTabStats);
  return /*#__PURE__*/_jsx(OverlayTrigger, {
    trigger: "click",
    placement: "top",
    rootClose: true,
    overlay: /*#__PURE__*/_jsxs(Popover, {
      id: "popover-permalink",
      children: [/*#__PURE__*/_jsxs(Popover.Title, {
        as: "h3",
        children: [/*#__PURE__*/_jsx(Link45deg, {
          className: "icon mr-1"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          id: "result.permalink"
        })]
      }), /*#__PURE__*/_jsx(Popover.Content, {
        children: /*#__PURE__*/_jsx(InlineCopy, {
          id: "input-permalink",
          text: url
        })
      })]
    }),
    children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      variant: "info",
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      disabled: disabled
    }, props), {}, {
      children: /*#__PURE__*/_jsx(PinFill, {
        className: "icon"
      })
    }))
  });
}
PermalinkButton.propTypes = {
  disabled: PropTypes.bool,
  isTabStats: PropTypes.bool
};
PermalinkButton.defaultProps = {
  disabled: false,
  isTabStats: false
};